import { put, select, takeEvery } from "redux-saga/effects";
import { updateModalContext } from "actions";
import { ConsignmentModalSection, ModalTypes } from "constants/navigation";
import { CREATE_NEW_CONSIGNMENT_FROM_RECEIVAL_LOT_FORM } from "constants/actionTypes";
import { CreateConsignmentAction } from "actions/modals/receivalLot";
import { getContextByModalType } from "selectors";
import { openModalAndWait, storeFormikSnapshot } from "./util";

function* createNewFromReceivalLot(action: CreateConsignmentAction) {
  const { receivalLotId, formikSnapshot } = action;

  // Store the current state of the form in the modal context
  // Close the current receival lot modal
  const snapshotId = yield storeFormikSnapshot(
    ModalTypes.EditReceivalLot,
    formikSnapshot,
  );

  const { resultAction } = yield openModalAndWait({
    modalType: ModalTypes.Consignment,
    returnTo: window.location.hash,
    context: {
      section: ConsignmentModalSection.GENERAL,
      values: { receivalLotIds: [receivalLotId] },
    },
    urlArgs: { section: ConsignmentModalSection.GENERAL },
  });

  const state = yield select();
  const modalContext = getContextByModalType(ModalTypes.EditReceivalLot)(state);

  const updatedValues = {
    ...modalContext.values,
    snapshotId,
  };
  // Reopen the receival lot modal with the new consignment selected

  if (resultAction) {
    // store the new consignment id in the form values.
    // When the receival lot modal is reopened, this will set the consignment id field.
    updatedValues.consignmentId = resultAction.result;
  }

  yield put(
    updateModalContext(ModalTypes.EditReceivalLot, {
      values: updatedValues,
    }),
  );
}

export function* receivalLotModalSagas() {
  yield takeEvery(
    CREATE_NEW_CONSIGNMENT_FROM_RECEIVAL_LOT_FORM,
    createNewFromReceivalLot,
  );
}
